import { msUtil } from 'core/ms_util.js';

window.adpWfmEmployees = (function($) {

  var config = {};

  var init = function(settings) {
    config = settings;

    if (config.currentlyWorking) {
      msUtil.spinner('adp-loading-spinner');
      startPolling();
      return;
    }

    initTooltips();
    initDataTable();
    initImportButtons();
    initDeactivateButtons();
    initDismissButtons();
    initImportAllPrompt();
    initResyncAllPrompt();
    initListeners();
  };

  var startPolling = function() {
    setInterval(function() {
      $.getJSON(config.statusPath, function(data) {
        if (data.loading === false) {
          window.location.reload();
        }
      });
    }, 5000);
  };

  var initDataTable = function() {
    $('table.adp-wfm-user-importer').dataTable({
      sPaginationType: 'full_numbers',
      iDisplayLength:  10,
      sDom:            '<"table-header"fl><"table-responsive"t><"table-footer"ip>',
      aaSorting:       [[ 1, 'desc' ]],
      aoColumns: [
        { bSortable: false, sWidth: '30px'  },
        { bSortable: true,  sWidth: '100px'  },
        { bSortable: true,                  },
        { bSortable: true,  sWidth: '130px' },
        { bSortable: true,  sWidth: '100px'  },
        { bSortable: true,  sWidth: '150px' },
        { bSortable: true,  sWidth: '120px'  }
      ],
      fnInitComplete: function() {
        initSelectAll();
        initImportSelectedButton();
      },
      fnDrawCallback: function() {
        updateImportSelectedVisibility();
      },
      oLanguage: dataTables_i18n
    });

    $('select.uniform, input:file, .dataTables_length select').uniform();
  };

  var initImportSelectedButton = function() {
    var btnHtml = '<button id="wfm-import-sel-btn" class="btn btn-success" style="display:none">' +
                  config.i18n.importSelected +
                  '</button>';
    $('.adp-wfm-user-importer').closest('.dataTables_wrapper')
      .find('.dataTables_filter')
      .append(btnHtml);
    $(document).on('click', '#wfm-import-sel-btn', handleImportSelected);
  };

  var handleImportSelected = function() {
    $('#wfm-import-sel-btn').prop('disabled', true);

    $('.employee-checkbox:checked:not(:disabled)').each(function() {
      var $checkbox = $(this);
      var $btn      = $checkbox.closest('tr').find('.wfm-import-btn');
      if ($btn.length) {
        $btn.trigger('click');
      }
      $checkbox.prop('checked', false);
    });

    $('#all_employee_checkbox').prop('checked', false);
    hideImportSelectedBtn();
  };

  var showImportSelectedBtn = function() {
    $('#wfm-import-sel-btn').prop('disabled', false).show();
  };

  var hideImportSelectedBtn = function() {
    $('#wfm-import-sel-btn').hide();
  };

  var updateImportSelectedVisibility = function() {
    if (config.impersonating && $('.employee-checkbox:checked:not(:disabled)').length > 0) {
      showImportSelectedBtn();
    } else {
      hideImportSelectedBtn();
    }
  };

  var initSelectAll = function() {
    $(document).on('change', '#all_employee_checkbox', function() {
      $('.employee-checkbox:not(:disabled)').prop('checked', $(this).is(':checked'));
      updateImportSelectedVisibility();
    });

    $(document).on('change', '.employee-checkbox', function() {
      var enabled    = $('.employee-checkbox:not(:disabled)');
      var allChecked = enabled.length > 0 && enabled.filter(':not(:checked)').length === 0;
      $('#all_employee_checkbox').prop('checked', allChecked);
      updateImportSelectedVisibility();
    });
  };

  var initDismissButtons = function() {
    $(document).on('click', '.dismiss-error-button', function(e) {
      e.preventDefault();

      var $link      = $(this);
      var $errorDiv  = $link.closest('.adp-user-error');
      var dismissUrl = $link.data('dismiss-url');

      var promptContent  = '<h4>' + config.i18n.dismissWarningTitle + '</h4>';
          promptContent += '<div>' + config.i18n.dismissWarningBody + '</div>';

      bootbox.dialog(promptContent, [
        {
          label: config.i18n.cancel,
          class: 'btn'
        },
        {
          label: config.i18n.dismissError,
          class: 'btn-danger',
          callback: function() {
            $.ajax({
              method:  'DELETE',
              url:      dismissUrl,
              data:     { authenticity_token: config.csrfToken },
              success:  function() {
                $errorDiv.hide();
                $(document).trigger('wfm_error_messages.decrement');
              }
            });
          }
        }
      ]);
    });
  };

  var initImportAllPrompt = function() {
    var promptContent  = '<h4>' + config.i18n.importAllConfirmTitle + '</h4>';
        promptContent += '<div>' + config.i18n.importAllConfirmBody + '</div>';

    $('#wfm-import-all-btn').on('click', function() {
      bootbox.dialog(promptContent, [
        { label: config.i18n.cancel,        class: 'btn' },
        { label: config.i18n.importAllCallout, class: 'btn-danger', callback: function() {
            $('#wfm-import-all-form').get(0).submit();
          }
        }
      ]);
    });
  };

  var initResyncAllPrompt = function() {
    var promptContent  = '<h4>' + config.i18n.resyncAllConfirmTitle + '</h4>';
        promptContent += '<div>' + config.i18n.resyncAllConfirmBody + '</div>';

    $('#wfm-resync-all-btn').on('click', function() {
      bootbox.dialog(promptContent, [
        { label: config.i18n.cancel,         class: 'btn' },
        { label: config.i18n.resyncAllCallout, class: 'btn-danger', callback: function() {
            $('#wfm-resync-all-form').get(0).submit();
          }
        }
      ]);
    });
  };

  var initListeners = function() {
    $(document).on('wfm_error_messages.decrement', function() {
      var $alert = $('#import-failure-alert');
      var $count = $('#import-failure-count');
      var current = parseInt($count.text(), 10) || 1;
      var next    = current - 1;

      if (next <= 0) {
        $alert.hide();
      } else {
        $count.text(next);
      }
    });
  };

  var initTooltips = function() {
    $(document).on('mouseenter', 'tr', function() {
      $(this).find('[data-toggle="tooltip"]').tooltip();
    });
  };

  var statusCell = function($btn) {
    return $btn.closest('tr').find('.adp-user-import-status');
  };

  var setError = function($btn, msg, dismissUrl) {
    var dismissHtml = dismissUrl
      ? ' <a class="dismiss-error-button" data-dismiss-url="' + dismissUrl + '" data-toggle="tooltip" data-container="body" title="' + config.i18n.dismissErrorTooltip + '">' + config.i18n.dismiss + '</a>'
      : '';
    statusCell($btn)
      .show()
      .html('<i class="fa fa-exclamation-triangle text-error" data-toggle="tooltip" data-container="body" title="' + msg + '">&nbsp;</i>' + dismissHtml)
      .addClass('adp-user-error');
  };

  var setImported = function($btn) {
    statusCell($btn).html('<i class="fa fa-check">&nbsp;</i>').removeClass('adp-user-error');
  };

  var clearStatus = function($btn) {
    statusCell($btn).html('&nbsp;').removeClass('adp-user-error');
  };

  var initImportButtons = function() {
    $(document).on('click', '.wfm-import-btn', function() {
      var $btn = $(this);
      $btn.prop('disabled', true).text(config.i18n.importing);

      $.ajax({
        url:  $btn.data('import-url'),
        type: 'POST',
        data: { authenticity_token: config.csrfToken },
        success: function(data) {
          var deactivateUrl = $btn.data('import-url').replace('import_employee', 'deactivate_employee');
          setImported($btn);

          if (data.user_path) {
            var $nameCell = $btn.closest('tr').find('td:nth-child(3)');
            var name = $nameCell.text().trim();
            $nameCell.html('<a href="' + data.user_path + '">' + name + '</a>');
          }

          $btn.closest('tr').find('.employee-checkbox').prop('disabled', true).prop('checked', false);
          updateImportSelectedVisibility();

          $btn.replaceWith(
            '<button class="btn btn-danger wfm-deactivate-btn" data-deactivate-url="' + deactivateUrl + '">' +
            config.i18n.deactivate +
            '</button>'
          );
        },
        error: function(xhr) {
          var msg        = xhr.responseJSON && xhr.responseJSON.message ? xhr.responseJSON.message : config.i18n.importError;
          var dismissUrl = $btn.data('import-url').replace('import_employee', 'dismiss_error');
          $btn.prop('disabled', false).text(config.i18n.import);
          setError($btn, msg, dismissUrl);
        }
      });
    });
  };

  var initDeactivateButtons = function() {
    $(document).on('click', '.wfm-deactivate-btn', function() {
      var $btn = $(this);

      var promptContent = '<h4 class="text-error">' + config.i18n.deactivateWarningTitle + '</h4>';
      promptContent    += '<div>' + config.i18n.deactivateWarningBody + '</div>';

      bootbox.dialog(promptContent, [
        {
          label: config.i18n.cancel,
          class: 'btn'
        },
        {
          label: config.i18n.deactivate,
          class: 'btn-danger',
          callback: function() {
            $btn.prop('disabled', true).text(config.i18n.deactivating);

            $.ajax({
              url:  $btn.data('deactivate-url'),
              type: 'POST',
              data: { authenticity_token: config.csrfToken },
              success: function() {
                var importUrl = $btn.data('deactivate-url').replace('deactivate_employee', 'import_employee');
                var $nameCell = $btn.closest('tr').find('td:nth-child(3)');
                var name      = $nameCell.find('a').text() || $nameCell.text().trim();
                $nameCell.text(name);

                $btn.closest('tr').find('.employee-checkbox').prop('disabled', false);

                clearStatus($btn);
                $btn.replaceWith(
                  '<button class="btn btn-success wfm-import-btn" data-import-url="' + importUrl + '">' +
                  config.i18n.import +
                  '</button>'
                );
              },
              error: function(xhr) {
                var msg        = xhr.responseJSON && xhr.responseJSON.message ? xhr.responseJSON.message : config.i18n.deactivateError;
                var dismissUrl = $btn.data('deactivate-url').replace('deactivate_employee', 'dismiss_error');
                $btn.prop('disabled', false).text(config.i18n.deactivate);
                setError($btn, msg, dismissUrl);
              }
            });
          }
        }
      ]);
    });
  };

  return { init: init };

})(jQuery);
